import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['dropdown', 'user'],
    blacklist: [],
    stateReconciler: (inboundState: any, originalState: any) => {
        if (!inboundState) return originalState;
        return inboundState;
    },
    transforms: [
        {
            in: (state: any) => {
                try {
                    return state;
                } catch (error) {
                    console.error('Error during persistence:', error);
                    return state;
                }
            },
            out: (state: any) => {
                try {
                    return state;
                } catch (error) {
                    console.error('Error during rehydration:', error);
                    return state;
                }
            },
        },
    ],
};

export default persistConfig;